exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-toggler {\r\n  cursor: pointer;\r\n }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// c:/WebProjects/angularcoin/src/app/component/top-nav/top-nav.component.css
// module id = ../../../../../src/app/component/top-nav/top-nav.component.css
// module chunks = main